import { render, staticRenderFns } from "./SuffixInput.vue?vue&type=template&id=2b6b2274&scoped=true"
import script from "./SuffixInput.vue?vue&type=script&lang=js"
export * from "./SuffixInput.vue?vue&type=script&lang=js"
import style0 from "./SuffixInput.vue?vue&type=style&index=0&id=2b6b2274&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6b2274",
  null
  
)

export default component.exports